<div class="container">
  <h2>{{ 'help.title' | cxTranslate }}</h2>
</div>
